import { useContext } from 'react'
import styled from 'styled-components'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { ModalWrap } from '../../../components/modal/ModalWrap'
import { Content } from '../../../components/container/Content'
import { Header } from '../../../components/header'

const OPEN_SOURCE = [
  // dependencies
  '@channel.io/channel-web-sdk-loader',
  '@hookform/resolvers',
  '@portone/browser-sdk',
  '@tanstack/react-query',
  '@tanstack/react-query-devtools',
  '@testing-library/react',
  '@types/styled-components',
  'airbridge-web-sdk-loader',
  'axios',
  'dayjs',
  'libphonenumber-js',
  'lodash',
  'lottie-react',
  'mobx',
  'mobx-react-lite',
  'path-to-regexp',
  'pretendard',
  'query-string',
  'react',
  'react-daum-postcode',
  'react-dom',
  'react-facebook-pixel',
  'react-hook-form',
  'react-hot-toast',
  'react-infinite-scroll-component',
  'react-lazy-load-image-component',
  'react-router',
  'react-router-dom',
  'react-scripts',
  'react-spinners',
  'styled-components',
  'swiper',
  'web-vitals',
  'yup',
  //devdependencies
  '@types/jest',
  '@types/lodash',
  '@types/react',
  '@types/react-dom',
  '@types/react-router-dom',
  '@typescript-eslint/eslint-plugin',
  '@typescript-eslint/parser',
  'eslint',
  'eslint-config-prettier',
  'eslint-plugin-prettier',
  'eslint-plugin-react',
  'eslint-plugin-react-hooks',
  'prettier',
  'rimraf',
  'typescript',
]

export function OpenSourceModal() {
  const { closeModal } = useContext(ModalContext)

  const dismiss = () => {
    closeModal(MODALS_ID.OPEN_SOURCE)
  }

  return (
    <ModalWrap>
      <Header type="MODAL" title="닫기" onDismiss={dismiss} />
      <StyledContent>
        <ul>
          {OPEN_SOURCE.map((v, i) => (
            <li key={i}>{v}</li>
          ))}
        </ul>
        last update 2025.07.25
      </StyledContent>
    </ModalWrap>
  )
}

const StyledContent = styled(Content)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
  ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-left: 16px;
  }
`
